module.exports = __webpack_public_path__ + "assets/img/warrior-name-55205ec1.png";